import React from 'react'
import { useTranslation } from 'react-i18next'
import { usePageContext } from 'pageContext'
import { Card } from 'packages/eid-ui'
import { Box } from '@mui/material'
import { EidAutocomplete } from 'packages/eid-controls'
import { Icon } from 'packages/eid-icons'
import { isNilOrEmpty } from 'packages/core'

const GroupOptionComponent = EidAutocomplete.getOptionComponent({
    type: 'label',
    labelProp: 'name',
})

const getOptionLabel = (option) => option.name

const AccountStoreFilter = ({ config }) => {
    const { t } = useTranslation()
    const [state, dispatch] = usePageContext()
    const queryParams = {
        trackingID: config?.trackingID,
        rtaLandscapeIdList:
            (Array.isArray(state?.landscapes) &&
                state?.landscapes?.map((landscape) => landscape.id)) ||
            [],
    }

    const filter = (
        <Box padding="18px">
            <EidAutocomplete.New
                placeholder={t('SelectAccountStore')}
                url={config?.url}
                queryParams={queryParams}
                getOptionLabel={getOptionLabel}
                dedupingInterval={60000}
                value={
                    state.accountStoreSelection
                        ? state.accountStoreSelection
                        : null
                }
                optionComponent={GroupOptionComponent}
                supportsServerSideSearch={false}
                minCharactersReqForSearch={0}
                clearIcon={
                    !isNilOrEmpty(state.accountStoreSelection) && (
                        <Icon
                            name="Close"
                            color="#959598"
                            onClick={() =>
                                dispatch({
                                    type: 'SET_PROP',
                                    payload: {
                                        key: 'accountStoreSelection',
                                        value: null,
                                    },
                                })
                            }
                        />
                    )
                }
                onChange={(_, value) => {
                    dispatch({
                        type: 'SET_PROP',
                        payload: {
                            key: 'accountStoreSelection',
                            value: value,
                        },
                    })
                }}
            />
        </Box>
    )

    return (
        <Card
            cardTitle={t('AccountStore')}
            color="#fff"
            collapsible
            expanded={Boolean(state.accountStoreSelection)}
        >
            {filter}
        </Card>
    )
}

export default AccountStoreFilter
